import React, { Component } from 'react';
import { images } from '../../../../settings';
import { BrowserRouter as Router, Link } from 'react-router-dom';

import './MercadoCapitais.scss';

class MercadoCapitais extends Component {
  constructor(props) {
    super(props);
    this.images = images;
  }
  render() {
    return (
      <div className="planos-template">
        <div className="planos-template--risca" style={{ backgroundColor: this.props.cor }}></div>
        <div className="planos-template__conteudo">
          <h3 className="h2 h2--500 planos-template__titulo" style={{ color: this.props.cor }}>
            Mercado de capitais
          </h3>
          <h4 className="planos-template__subtitulo">
            Para promover melhorias nos processos de emissão de ofertas públicas, foram traçados quatro objetivos
            estratégicos:
          </h4>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2019.icone_formentar_financiamento} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Formentar o financiamento de longo prazo</h5>
                <p>
                  Manutenção de uma agenda constante com a diretoria e a equipe técnica do BNDES. O intuito? Fortalecer
                  o papel do mercado de capitais como parceiro do banco de fomento no financiamento de longo prazo.
                  Também estiveram em discussão, em conjunto com o PPI (Programa de Parceria de Investimentos do
                  Ministério da Economia), melhorias aos modelos de concessão para ampliar a segurança jurídica dos
                  projetos de infraestrutura.
                </p>
                <p>
                  Em outra frente, a intenção era aproximar a Associação do poder judiciário: foi elaborado um plano de
                  aula, com base no livro TOP da CVM, para promover conteúdo de qualidade sobre o mercado de capitais
                  que possa auxiliar os juízes em decisões referentes ao mercado. O curso será disponibilizado em 2020.
                </p>
              </div>
            </div>
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2019.icone_volume} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Estimular o volume de emissões</h5>
                <p>
                  Para agilizar e simplificar as emissões de ofertas públicas, foi enviado à CVM um estudo de melhorias
                  nas Instruções 400 e 476, que regulam essas operações. Ele aborda a criação de regras específicas para
                  oferta de produtos estruturados, critérios mínimos para as ofertas privadas, melhorias nas informações
                  prestadas ao investidor, entre outros pontos.
                </p>
                <p>
                  Também foram discutidas melhorias na Lei 6.404, que trata das sociedades por ações – uma das
                  sugestões, a dispensa do boletim de subscrição para operações em mercados regulamentados, foi incluída
                  na publicação da{' '}
                  <Link className="text_link text_link--green" to="/iniciativa/lei-liberdade-economica">
                    Lei da Liberdade Econômica
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
          <div className="planos-template__linha">
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2019.icone_aumentar} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Aumentar a liquidez</h5>
                <p>
                  Publicação de dois guias que auxiliam na atividade dos formadores de mercado e na padronização da
                  metodologia de cálculo de debêntures, buscando estimular o desenvolvimento do mercado de renda fixa.
                  Apesar de não obrigatórios, os documentos reúnem boas práticas para o mercado.
                </p>
                <p>
                  A Associação também atuou com o BC tendo dois focos. Para desenvolver os COEs (Certificados de
                  Operações Estruturadas), a sugestão foi expandir a relação de ativos que servem como base para emissão
                  do produto. Sobre os derivativos de crédito, a proposta tratava da inclusão de estruturas que existem
                  no mercado internacional, como CCDS (Contingent Credit Default Swap) e opções de risco de crédito.
                </p>
              </div>
            </div>
            <div className="planos-template__coluna">
              <div className="planos-template__imagem-coluna">
                <img src={this.images.plano_acao_2019.icone_investidores} alt="Ícone" />
              </div>
              <div className="planos-template__conteudo-coluna">
                <h5 className="planos-template__titulo-coluna">Diversificar a base de investidores</h5>
                <p>
                  Envio ao governo de sugestões de mudanças na Lei 12.431, que regula as emissões de debêntures
                  incentivadas. O objetivo é estimular a participação de pessoas físicas e de investidores
                  institucionais na aquisição de ativos de longo prazo.
                </p>
                <p>
                  Para simplificar e harmonizar as regras para atração do investidor estrangeiro, fomos relatores na IMK
                  (Iniciativa Mercado de Capitais, grupo do governo para fomentar o setor) de uma proposta legal sobre
                  domicílio do investidor não residente e de ajuste na tributação dos FIPs (Fundos de Investimento em
                  Participações).
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="planos-template__footer">
          <a
            className="button button--aylen button--green button--border-medium button--size-m button--round-l button--text-thick"
            href="https://www.anbima.com.br/data/files/B5/B5/1F/15/375FE610DC784BE6192BA2A8/Relatorio_de_Iniciativas_2019.pdf "
            target="_blank"
          >
            Saiba mais no Relatório de Iniciativas
          </a>
        </div>
      </div>
    );
  }
}
export { MercadoCapitais };
